import React, { useContext, useEffect, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { SortOrder } from 'primereact/api';
import { getEntities } from 'app/api/generalApi';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import './mail-template.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { useAppSelector } from 'app/config/store';

const MailInbox = () => {
  const account = useAppSelector(state => state.authentication.account);
  const { showSuccess, showError } = useContext(ToastContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 20,
    page: 0,
    sortField: 'id',
    sortOrder: SortOrder.DESC,
    filter: '',
  });

  useEffect(() => {
    loadData();
  }, [lazyParams]);

  const loadData = () => {
    setLoading(true);

    const sort = lazyParams.sortField
      ? lazyParams.sortField + (lazyParams.sortOrder ? ',' + (lazyParams.sortOrder === SortOrder.DESC ? 'desc' : 'asc') : '')
      : null;

    const requestData = {
      page: lazyParams.page,
      size: lazyParams.rows,
      sort,
      ...(lazyParams.filter ? { query: lazyParams.filter } : {}),
    };

    getEntities('/api/email-messages', requestData)
      .then(response => {
        setData(response.data.content);
        setTotalRecords(response.data.totalElements);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const onDetail = emailMessage => {
    navigate(`/mail/inbox/${emailMessage.id}`);
  };

  const itemTemplate = (emailMessage, index) => {
    return (
      <div className="col-12" key={emailMessage.id}>
        <div
          className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', {
            'border-top-1 surface-border': index !== 0,
          })}
        >
          {emailMessage?.insuranceCompany?.logo && (
            <img
              className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round"
              src={`https://system.nfagroup.eu/api/insurance-companies/logo/${emailMessage.insuranceCompany.id}`}
              alt={emailMessage.subject}
            />
          )}
          {!emailMessage?.insuranceCompany?.logo && (
            <div className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" />
          )}
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <div className="text-2xl font-bold text-900">{emailMessage.subject}</div>
              {/*<Rating value={product.rating} readOnly cancel={false}></Rating>*/}
              <div className="flex align-items-center gap-3">
                <span className="flex align-items-center gap-2">
                  <span className="three-line-clamp" dangerouslySetInnerHTML={{ __html: emailMessage.message }}></span>
                </span>
                {/*<Tag value={product.inventoryStatus} severity={getSeverity(product)}></Tag>*/}
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              <Button icon="pi pi-arrow-right" className="p-button-rounded" type="button" onClick={() => onDetail(emailMessage)}></Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const listTemplate = items => {
    if (!items || items.length === 0) return null;

    const list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <div className="card">
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
      {!loading && (
        <>
          <div className="d-flex mb-5 justify-content-between">
            <h1>Zoznam noviniek</h1>
            {hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN]) && (
              <Button icon="pi pi-plus" onClick={() => navigate('/mail/compose')}>
                <b>Vytvoriť novinku</b>
              </Button>
            )}
          </div>
          <DataView value={data} itemTemplate={itemTemplate} emptyMessage="Žiadne novinky" />
        </>
      )}
    </div>
  );
};

export default MailInbox;
